"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonCell = exports.Cell = exports.Row = exports.Body = exports.Header = exports.Table = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Table = styled_components_1.default.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: 6px 0 18px rgba(0, 0, 0, 0.06);\n  max-height: 100%;\n  width: 100%;\n  background-color: #fff;\n  border-collapse: collapse;\n  margin-bottom: 5px;\n"], ["\n  box-shadow: 6px 0 18px rgba(0, 0, 0, 0.06);\n  max-height: 100%;\n  width: 100%;\n  background-color: #fff;\n  border-collapse: collapse;\n  margin-bottom: 5px;\n"])));
exports.Header = styled_components_1.default.thead(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 4px 4px 0 0;\n  background-color: ", ";\n  position: sticky;\n  top: 0;\n  z-index: 1; /* This z-index is needed to prevent transparent of checkbox */\n"], ["\n  border-radius: 4px 4px 0 0;\n  background-color: ", ";\n  position: sticky;\n  top: 0;\n  z-index: 1; /* This z-index is needed to prevent transparent of checkbox */\n"])), function (props) { return props.theme.colors.white; });
exports.Body = styled_components_1.default.tbody(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 0 0 4px 4px;\n  overflow-y: scroll;\n"], ["\n  border-radius: 0 0 4px 4px;\n  overflow-y: scroll;\n"])));
exports.Row = styled_components_1.default.tr(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", " > &, ", " > div > & {\n    height: 64px;\n    background-color: ", ";\n  }\n\n  box-sizing: border-box;\n  justify-content: left;\n  font-size: 13px;\n  color: ", ";\n  border-bottom: ", ";\n  border-top: ", ";\n  border-left: ", ";\n  font-weight: ", ";\n  overflow: hidden;\n"], ["\n  ", " > &, ", " > div > & {\n    height: 64px;\n    background-color: ", ";\n  }\n\n  box-sizing: border-box;\n  justify-content: left;\n  font-size: 13px;\n  color: ", ";\n  border-bottom: ", ";\n  border-top: ", ";\n  border-left: ", ";\n  font-weight: ", ";\n  overflow: hidden;\n"])), exports.Body, exports.Body, function (props) { return (props.selected ? props.theme.colors.red5 : props.theme.colors.white); }, function (props) { return props.theme.colors.tableBlack2; }, function (props) { var _a; return ((_a = props.borderBottom) !== null && _a !== void 0 ? _a : true) ? "2px ".concat(props.theme.colors.gray2Transparent, " solid") : undefined; }, function (props) { var _a; return (((_a = props.borderTop) !== null && _a !== void 0 ? _a : false) ? "2px ".concat(props.theme.colors.gray2Transparent, " solid") : undefined); }, function (props) {
    var _a;
    switch (props.level || "none") {
        case "error":
            return "2px ".concat(props.theme.colors.red2, " solid;");
        case "warn":
            return "2px ".concat(props.theme.colors.yellow, " solid;");
        case "ok":
            return "2px ".concat(props.theme.colors.green, " solid;");
        case "edited":
            return "2px ".concat(props.theme.colors.gray3, " solid;");
        case "none":
            return "2px ".concat((_a = props.leftBorderColor) !== null && _a !== void 0 ? _a : "transparent", " solid");
    }
}, function (props) { var _a; return (((_a = props.borderTop) !== null && _a !== void 0 ? _a : false) ? "bold" : undefined); });
exports.Cell = styled_components_1.default.td(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n\n  ", "\n\n  color: ", ";\n\n  ", " & {\n    padding: 8px 12px;\n    line-height: 30px;\n  }\n\n  ", " & {\n    padding: 8px 12px;\n    &:last-child {\n      border-radius: 0 0 4px 4px;\n    }\n  }\n  box-sizing: border-box;\n  ", "\n\n  & > svg {\n    vertical-align: sub;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  ", ";\n\n  ", "\n\n  color: ", ";\n\n  ", " & {\n    padding: 8px 12px;\n    line-height: 30px;\n  }\n\n  ", " & {\n    padding: 8px 12px;\n    &:last-child {\n      border-radius: 0 0 4px 4px;\n    }\n  }\n  box-sizing: border-box;\n  ", "\n\n  & > svg {\n    vertical-align: sub;\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
    var flex = props.flex, px = props.px, percent = props.percent, col = props.col;
    if (flex !== undefined) {
        return {
            flex: flex,
        };
    }
    else if (px !== undefined) {
        return {
            flex: "0 0 ".concat(px, "px"),
        };
    }
    else if (percent !== undefined) {
        return {
            flex: "0 0 ".concat(percent, "%"),
        };
    }
    else if (col !== undefined) {
        return {
            flex: "0 0 ".concat((col / 12) * 100, "%"),
        };
    }
    else {
        return undefined;
    }
}, function (props) {
    return props.px === 0 || props.percent === 0 || props.col === 0
        ? {
            display: "none",
        }
        : undefined;
}, function (props) {
    switch (props.level || "none") {
        case "error":
            return props.theme.colors.red2;
        case "warn":
            return props.theme.colors.yellow;
        case "ok":
            return props.theme.colors.green;
        case "none":
        default:
            return props.theme.colors.tableBlack2;
    }
}, exports.Header, exports.Body, function (props) {
    return props.wrap
        ? {
            margin: "auto 0",
            lineHeight: "20.25px",
        }
        : {
            lineHeight: "46px",
            whiteSpace: "nowrap",
        };
}, function (props) { return (props.onClick ? "cursor: pointer;" : undefined); }, function (props) { return (props.display ? "display: ".concat(props.display, ";") : undefined); });
exports.ButtonCell = (0, styled_components_1.default)(exports.Cell)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  & > button,\n  & > a {\n    margin-top: 7px;\n    margin-right: 16px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"], ["\n  display: flex;\n  & > button,\n  & > a {\n    margin-top: 7px;\n    margin-right: 16px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
